export default "<p style=\"font-size: 50px; font-weight: bold;\">\n  {{ text }}\n</p>\n"